module.exports = __webpack_public_path__ + "img/mainPicture_mobile.38d1e581.png";